class CountDown {
  cycle_number = 0; // 循环次数
  downEndTime = new Date(); // 倒计时结束时间
  timeDoms = null; // 倒计时的节点列表
  time_zones = null; // 时区
  constructor({
    timeDoms,
    startTime,
    downEndTime,
    callback,
    countdown_cycle,
    time_zones = "Europe/Berlin",
  }) {
    this.timeDoms = timeDoms;
    this.countdown_cycle = Number(countdown_cycle ?? 0);
    this.callback = callback;
    this.time_zones = time_zones;
    this.startTime = startTime;
    this.downEndTime = downEndTime;
  }

  initCountDown() {
    this.initTime();
    if (this.intervalTime) {
      clearInterval(this.intervalTime);
    }
    this.intervalTime = setInterval(this.setIntervalTime.bind(this), 1000);
  }
  initTime() {
    dayjs.extend(window.dayjs_plugin_utc);
    dayjs.extend(window.dayjs_plugin_timezone);
  }

  // 获取当前时间
  getCurrentTime() {
    return dayjs.tz(dayjs(), this.time_zones);
  }

  // 获取目标时区时间
  getTargetTimezone(targetTime) {
    return dayjs.tz(targetTime, this.time_zones);
  }

  // 倒计时
  setIntervalTime() {
    // console.log('date',this.getCurrentTime().format('YYYY-MM-DD HH:mm:ss'))
    let nowTime = this.getCurrentTime().valueOf();
    let setTime = this.compareTime(this.startTime, this.downEndTime).valueOf(); //设置结束时间

    let remianAllSeconds = Math.floor((setTime - nowTime) / 1000); //剩余总秒数
    if (remianAllSeconds <= 0) {
      if (this.countdown_cycle) {
        // 周期循环
        // this.cycle_number += 1;
        this.downEndTime = this.getTargetTimezone(this.downEndTime).add(this.countdown_cycle, 'day').format("YYYY/MM/DD HH:mm:ss")
        clearInterval(this.intervalTime);
        this.intervalTime = setInterval(this.setIntervalTime.bind(this), 1000);
        return;
      } else {
        clearInterval(this.intervalTime);
        this.callback?.();
        return;
      }
    }
    let remainDays = Math.floor(remianAllSeconds / (60 * 60 * 24)); //剩余天数
    let remainHours = Math.floor((remianAllSeconds / (60 * 60)) % 24); //剩余小时数
    let remainMinutes = Math.floor((remianAllSeconds / 60) % 60); //剩余分钟数
    let remainSeconds = Math.floor(remianAllSeconds % 60); //剩余秒数
    if (this.timeDoms) {
      this.timeDoms[0].innerText = String(remainDays).padStart(2, "0");
      this.timeDoms[1].innerText = String(remainHours).padStart(2, "0");
      this.timeDoms[2].innerText = String(remainMinutes).padStart(2, "0");
      this.timeDoms[3].innerText = String(remainSeconds).padStart(2, "0");
    }

    this.callback?.({
      remainDays,
      remainHours,
      remainMinutes,
      remainSeconds,
    });
  }

  compareTime(startTime, downEndTime) {
    if (
      startTime &&
      !this.getTargetTimezone(startTime).isBefore(this.getCurrentTime())
    ) {
      return this.getTargetTimezone(startTime);
    }
    return this.getTargetTimezone(downEndTime);
  }
  getNowDate(localTime = Date.now(), timeZone = 8) {
    let timezone = timeZone; //目标时区时间，东八区
    // 本地时间和格林威治的时间差，单位为分钟
    let offset_GMT = new Date().getTimezoneOffset();
    // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
    let nowDate = localTime;
    let targetDate =
      nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000;
    console.log(new Date(targetDate).toLocaleString());
    return targetDate;
  }

  /**
   *
   * @param {日期} date
   * @param {周期} cycle
   * @returns 过去n天日期
   */
  getPastDates(date, cycle) {
    let oDate = date.getTime();
    let nDate = oDate + cycle * 24 * 3600 * 1000;
    // let y = nDate.getFullYear().toString().padStart(2, 0);
    // let m = (nDate.getMonth() + 1).toString().padStart(2, 0);
    // let d = nDate.getDate().toString().padStart(2, 0);
    // return `${y}${seperator}${m}${seperator}${d}`
    return new Date(nDate);
  }
}

class ProgressBar extends CountDown {
  end_x = 725;
  middle_x = 375;
  o_x = 25; // 原点
  o_y = 100;
  default_color = "#747474";
  line_active_color = "#81EC76";
  text_active_color = "#fff";
  isFirst = true;
  canvasCurrentText = {
    top_text: "",
    currentTime: "",
    bottom_text: "",
    o_x: 0,
    o_y: 0,
    text_color: this.default_color,
    point_color: this.line_active_color,
  };

  /**
   * 实例化画布
   * @param container     画布容器
   * @param canvasH       画布高
   * @param canvasW       画布宽
   * @param ratio         屏幕分辨率
   */
  constructor({
    container,
    canvasH,
    canvasW,
    ratio,
    preTime,
    startTime,
    endTime,
    texts,
  }) {
    super({});
    this.canvas = this.createHiDPICanvas(canvasW, canvasH, ratio);
    this.preTime = preTime;
    this.endTime = endTime;
    this.startTime = startTime;
    this.texts = texts;
    container.appendChild(this.canvas);
  }

  initCanvas() {
    const ctx = this.canvas.getContext("2d");
    this.ctx = ctx;

    // 起点
    this.drawLine(this.end_x, this.o_y, this.default_color);
    this.drawPoint(this.line_active_color, this.o_x, this.o_y);
    this.drawText(this.getTargetTimezone(this.preTime).format("MM-DD"), 0, 80);
    this.drawText(this.texts[0], 0, 135);

    // 结束端点
    this.drawPoint(this.default_color, this.end_x, this.o_y, ctx);

    this.updateCurrentDate();
    this.drawCurrentText();

    this.startInterval();
  }

  updateCurrentDate() {
    let isBefore = this.getTargetTimezone(this.endTime).isBefore(
      this.getCurrentTime()
    );
    this.canvasCurrentText = {
      ...this.canvasCurrentText,
      top_text: this.compareTime(this.startTime, this.endTime).format("MM-DD"),
      bottom_text: !this.getTargetTimezone(this.startTime).isBefore(
        this.getCurrentTime()
      )
        ? this.texts[1]
        : this.texts[2],
      text_color: isBefore ? this.text_active_color : this.default_color,
      point_color: isBefore ? this.line_active_color : this.default_color,
    };
  }

  // 绘制当前节点需要显示的时间节点
  drawCurrentText() {
    this.drawPoint(
      this.canvasCurrentText.point_color,
      this.end_x,
      this.o_y
    );
    this.drawText(
      this.canvasCurrentText.top_text,
      690,
      80,
      this.canvasCurrentText.text_color
    );
    this.drawText(
      this.canvasCurrentText.bottom_text,
      665,
      135,
      this.canvasCurrentText.text_color
    );
  }

  startInterval() {
    clearInterval(this.time);
    this.time = setInterval(() => {
      if(this.getTargetTimezone(this.startTime).isBefore(this.getCurrentTime())){
        this.updateCurrentDate();
        this.drawCurrentText();
      }
      if (
        this.getTargetTimezone(this.endTime).isBefore(this.getCurrentTime())
      ) {
        this.updateCurrentDate();
        this.drawCurrentText();
        clearInterval(this.time);
        return;
      }
      
      // 总天数
      let totalDate = dayjs(
        this.compareTime(this.startTime, this.endTime)
      ).diff(this.getTargetTimezone(this.preTime), "day");
      // 步长
      let step = (this.end_x - this.o_x) / totalDate;

      // 当前总差值
      let currentDiff =
        totalDate -
        dayjs(this.compareTime(this.startTime, this.endTime)).diff(
          this.getCurrentTime(),
          "day"
        );
      this.drawLine(
        this.o_x + step * currentDiff,
        this.o_y,
        this.line_active_color
      );
    }, 1000);
  }

  // 绘制文本
  drawText(text, offx1, offx2, fillStyle = "#fff") {
    let ctx = this.ctx
    ctx.fillStyle = fillStyle;
    ctx.font = "20px Open Sans"; // 设置文案大小和字体
    ctx.clearRect(offx1, offx2, this.canvasW, this.canvasH);
    ctx.fillText(text, offx1, offx2);
  }

  // 绘制点
  drawPoint(color, x, y) {
    let ctx=this.ctx;
    ctx.clearRect(x, y, this.canvasW, this.canvasH);
    ctx.beginPath(); //开始路径
    ctx.lineWidth = 11;
    ctx.strokeStyle = color;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.moveTo(x, y);
    ctx.lineTo(x, y);
    ctx.stroke(); //描边路径
  }

  // 绘制线
  drawLine(x = 750, y = this.o_y, strokeStyle = "#747474") {
    let ctx=this.ctx;
    ctx.clearRect(x, y, this.canvasW, this.canvasH);
    ctx.beginPath(); //开始路径
    ctx.lineWidth = 3;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = strokeStyle;
    ctx.moveTo(this.o_x, this.o_y);
    ctx.lineTo(x, y);
    ctx.closePath(); //结束路径
    ctx.stroke(); //描边路径
  }

  // 处理canvas绘制模糊问题
  adaptDPR(canvas, cb) {
    // 在初始化 canvas 的时候就要调用该方法
    const dpr = window.devicePixelRatio;
    const { width, height } = canvas;
    // 重新设置 canvas 自身宽高大小和 css 大小。放大 canvas；css 保持不变
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    canvas.style.width = width / 100 + "rem";
    canvas.style.height = height / 100 + "rem";
    // 直接用 scale 放大整个坐标系，相对来说就是放大了每个绘制操作
    cb?.(dpr);
  }

  getMonthAndDate(date) {
    return (
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0")
    );
  }

  /**
   * 创建高分辨率画布
   * @param w     画布宽
   * @param h     画布高
   * @param ratio 屏幕分辨率
   */
  createHiDPICanvas(w, h, ratio) {
    const PIXEL_RATIO = (function () {
      const c = document.createElement("canvas"),
        ctx = c.getContext("2d"),
        dpr = window.devicePixelRatio || 1,
        bsr =
          ctx["webkitBackingStorePixelRatio"] ||
          ctx["mozBackingStorePixelRatio"] ||
          ctx["msBackingStorePixelRatio"] ||
          ctx["oBackingStorePixelRatio"] ||
          ctx["backingStorePixelRatio"] ||
          1;

      return dpr / bsr;
    })();

    if (!ratio) {
      ratio = PIXEL_RATIO;
    }
    const can = document.createElement("canvas");
    can.width = w * ratio;
    can.height = h * ratio;
    can.style.width = w / 100 + "rem";
    can.style.height = h / 100 + "rem";
    can.getContext("2d").setTransform(ratio, 0, 0, ratio, 0, 0);
    return can;
  }
}
